import './styles.scss';
import 'react-toastify/dist/ReactToastify.css';

import {
  PageHeader,
  FAQSection,
  HeroSection,
  FooterSection,
  WhatWeDoSection,
  OurValuesSection,
  OurServiceSection,
  RepairProsTipsSection,
} from './sections';
import { ToastContainer } from 'react-toastify';
import ContactUsSection from './sections/contact-us-section/contactUsSection';
import { ProjectSection } from './sections/projects-section/ProjectSection';

const App = () => {
  return (
    <div>
      <ToastContainer />
      <PageHeader />
      <HeroSection />
      <WhatWeDoSection />
      <OurServiceSection />
      <RepairProsTipsSection />
      <OurValuesSection />
      <ProjectSection />
      <FAQSection />
      <ContactUsSection />
      <FooterSection />
    </div>
  );
};

export default App;
